import {
  Component,
  EventEmitter,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { MyFile } from 'src/app/helpers/Interfaces/my-file';
import { DataService } from 'src/app/helpers/data.service';
import { NotificationsService } from 'src/app/layout/components/navbar/navbar-notification/notifications.service';
import { StatusesService } from '../../../setup/statuses/statuses.service';
import { FeaturesService } from '../../../i-team/features/features.service';
import { ModulesService } from '../../../i-team/modules/modules.service';
import { ProjectsService } from '../../../i-team/projects/projects.service';
import { CustomerService } from '../../../lead-konnekt/customer/customer.service';
import { TicketsService } from '../tickets.service';
// import { catchError } from 'rxjs/operators';

@Component({
  selector: 'uat-ticket-add',
  templateUrl: './add-for-uat.component.html',
  styleUrls: ['./add-for-uat.component.scss'],
})
export class UatTicketAddComponent implements OnDestroy {
  @ViewChild('addTicketModal') public addTicketModal!: TemplateRef<any>;
  @Output('onTicketChange') onTicketChange = new EventEmitter<any>();
  @Output('onFilesChange') onFilesChange = new EventEmitter<any>();
  public btnText: string = 'Add';
  protected loading: boolean = false;
  public form: FormGroup;
  public _ticketServ!: TicketsService;
  public _toastrServ!: ToastrService;
  private _unsubscribeAll: Subject<any>;
  private _role: string;

  public files: Array<MyFile | File> = [];
  protected customers: Array<any> = [];
  protected projects: Array<any> = [];
  public modules: Array<any> = [];
  public features: Array<any> = [];
  protected customersLoading: boolean = false;
  protected projectsLoading: boolean = false;
  protected modulesLoading: boolean = false;
  protected featuresLoading: boolean = false;

  protected priorities: Array<any> = [
    {
      id: 'low',
      title: 'Low',
    },
    {
      id: 'normal',
      title: 'Normal',
    },
    {
      id: 'high',
      title: 'High',
    },
  ];
  protected services: Array<any> = [
    {
      id: 'bug',
      title: 'Bug / Issue',
    },
    {
      id: 'enhancement',
      title: 'Enhancement / Change Request',
    },
  ];
  private status: any;
  public init() {
    // console.log(this._role);

    if (this.projects.length == 0 && this._role == 'customer') {
      this.GetProjects();
    }
    if (this.customers.length == 0 && this._role == 'employee') {
      this.GetCustomers();
    }
    this.GetStatus();
  }

  constructor(
    _fb: FormBuilder,
    private _projectServ: ProjectsService,
    private _modulesServ: ModulesService,
    private _featureServ: FeaturesService,
    private _dataServ: DataService,
    private _statusServ: StatusesService,
    private _customerServ: CustomerService,
    private _notificationServ: NotificationsService
  ) {
    this._unsubscribeAll = new Subject<any>();
    this.form = _fb.nonNullable.group({
      projectId: [null, [Validators.required]],
      moduleId: [null],
      featureId: [null],
      priority: ['low', [Validators.required]],
      subject: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(?![\s\-_&!@#$%^*()+=,./?<>|~`{}[\]:;"'\\]+$)(?![\s\-]+$)(?!\d+$)[A-Za-z0-9\s\-_&!@#$%^*()+=,./?<>|~`{}[\]:;"'\\]+$/
          ),
        ],
      ],
      relatedService: [null, [Validators.required]],
      body: ['', [Validators.required]],
      ticketNumber: [''],
      customerId: [
        this._dataServ.customerValue?.id ?? null,
        [Validators.required],
      ],
      employeeId: [null],
      assignedDate: [null],
      employeeStatus: [_dataServ.roleValue == 'customer'],
      customerStatus: [_dataServ.roleValue == 'employee'],
    });

    this.fCustomerId?.valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((customerId) => {
        if (customerId) this.GetProjects(customerId);
        this.fProjectId?.setValue(null);
        this.fModuleId?.setValue(null);
        this.fFeatureId?.setValue(null);
      });
    this.fProjectId?.valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((projectId) => {
        if (projectId) this.GetModules(projectId);
        this.fModuleId?.setValue(null);
        this.fFeatureId?.setValue(null);
      });
    this.fModuleId?.valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((moduleId) => {
        if (moduleId) this.GetFeatures(moduleId);
        this.fFeatureId?.setValue(null);
      });
    this.fCustomerId?.setValue(this._dataServ.customerValue?.id || null);
    this._role = this._dataServ.roleValue;
  }
  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  get fProjectId() {
    return this.form.get('projectId');
  }
  get fModuleId() {
    return this.form.get('moduleId');
  }
  get fFeatureId() {
    return this.form.get('featureId');
  }
  get fCustomerId() {
    return this.form.get('customerId');
  }
  protected get fEmployeeId() {
    return this.form.get('employeeId');
  }
  protected get fPriority() {
    return this.form.get('priority');
  }
  protected get fSubject() {
    return this.form.get('subject');
  }
  protected get fRelatedService() {
    return this.form.get('relatedService');
  }
  protected get fBody() {
    return this.form.get('body');
  }

  protected GetProjects(id?: string) {
    this.projectsLoading = true;
    this._projectServ
      .GetProjects(id || this._dataServ.customerValue?.id)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (projects) => {
          this.projectsLoading = false;
          this.projects = projects.projects;
          if (this.projects.length === 1) {
            this.fProjectId?.setValue(this.projects[0]?.id);
          }
        },
      });
  }
  protected GetCustomers() {
    this.customersLoading = true;
    this._customerServ
      .GetAllCustomers({ skipPagination: true })
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (customers) => {
          this.customersLoading = false;
          // console.log(customers);

          this.customers = customers.data;
        },
      });
  }
  protected GetStatus() {
    if (!this.status) {
      this._statusServ.GetStatusByName('pending').subscribe({
        next: (status) => {
          this.status = status;
        },
        error: (err) => console.error(err),
      });
    }
  }
  protected GetModules(pId: string) {
    this.modulesLoading = true;
    this._modulesServ
      .GetModules(pId)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (modules) => {
          this.modules = modules;
          this.modulesLoading = false;
        },
        error: () => this._toastrServ.error('Something went wrong...'),
      });
  }
  protected GetFeatures(mId: string) {
    this.featuresLoading = true;
    this._featureServ
      .GetFeatures(mId)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (features) => {
          this.features = features;
          this.featuresLoading = false;
        },
        error: () => this._toastrServ.error('Something went wrong...'),
      });
  }
  protected onFileSelect(input: any) {
    this.files = [...this.files, ...input.target.files];
  }
  protected RemoveFile(file: any) {
    if (file.id) {
      this._ticketServ
        .DeleteTicketFile(file.id)
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe({
          next: () => {
            this.files = this.files.filter((f) => f !== file);
            this.onFilesChange.emit({
              ticketId: this.form.value.id,
              fileId: file.id,
            });
          },
          error: () => {
            this._toastrServ.error('Something went wrong...');
          },
        });
    } else {
      this.files = this.files.filter((f) => f !== file);
    }
  }
  protected closeModal(modal: any) {
    modal.dismiss('Cross click');
  }
  protected submitted: boolean = false;
  protected onSubmit(modal: any) {
    if (this.form.invalid) {
      this.submitted = true;
      return;
    }

    this.loading = true;
    const payload = { ...this.form.value, from: 'uat' };
    payload.subject = payload.subject.trim();
    const serviceMethod = this._ticketServ.AddTicket(payload);

    serviceMethod.pipe(takeUntil(this._unsubscribeAll)).subscribe({
      next: (ticket) => {
        const payload = {
          content: ticket.subject,
          timestamp: new Date().toISOString(),
          employeeTypes: [
            {
              employeeType: 'scrum-master',
            },
            {
              employeeType: 'project-manager',
            },
          ],
          specificUsers: [] as { userId: string }[],
          for: 'ticket',
          title: `<span class='font-weight-bolder'>${
            this._dataServ.userValue?.name
          }</span> generated a change request ${
            this._dataServ.roleValue == 'employee'
              ? `on behalf of ${
                  this.customers.find((c) => c.id == ticket.customerId).name
                }`
              : ''
          }`,
          tcId: ticket.id,
        };
        if (this._dataServ.roleValue == 'employee') {
          payload.specificUsers.push({
            userId: this.customers.find((c) => c.id == ticket.customerId)
              ?.userId,
          });
        }
        this._notificationServ.AddNotification(payload).subscribe({
          error: (err) => {
            this._toastrServ.error(
              'Something went wrong while sending notifications.'
            );
          },
        });
        if (this.files.some((x: any) => !x.id)) {
          const filesPayload = new FormData();
          filesPayload.set('TicketGenerateId', ticket.id);
          this.files.forEach((x: any) => {
            if (!x.id) {
              filesPayload.append('Files', x);
            }
          });

          if (filesPayload.has('Files')) {
            this._ticketServ
              .AddTicketFiles(filesPayload)
              .pipe(takeUntil(this._unsubscribeAll))
              .subscribe({
                next: (files) => {
                  this._HandleSuccess(ticket, modal);
                },
                error: (err1) => {
                  console.warn(err1);

                  this._HandleError();
                },
              });
          } else {
            this._HandleSuccess(ticket, modal);
          }
        } else {
          this._HandleSuccess(ticket, modal);
        }
      },
      error: (err) => {
        console.warn(err);

        this._HandleError();
      },
    });
  }
  private _HandleError() {
    this.loading = false;
    this._toastrServ.error('Something went wrong...');
  }
  private _HandleSuccess(ticket: any, modal: any) {
    const ticketStatusPayload = {
      customerId: this.form.value.customerId,
      employeeId: null,
      statusId: this.status.id,
      ticketId: ticket.id,
    };
    this._ticketServ.AddTicketStatus(ticketStatusPayload).subscribe({
      next: () => {
        this._ticketServ.GetTicketById(ticket.id).subscribe({
          next: (res) => {
            this.onTicketChange.emit(res);
            this.loading = false;
            this.form.reset();
            modal.dismiss('Submitted...');
          },
          error: (err1) => {
            console.error(err1);
            this._toastrServ.error('Something went wrong...');
          },
        });
      },
      error: (err) => {
        console.error(err);
        this._toastrServ.error('Something went wrong...');
      },
    });
  }
}
